import React from 'react';
import { VictoryChart, VictoryLine, VictoryAxis, VictoryLabel } from 'victory';

const EmptyStateChart = () => {
  // Hardcoded empty data
  const emptyData = [
    { x: 'Jan', y: 0 },
    { x: 'Feb', y: 0 },
    { x: 'Mar', y: 0 },
    { x: 'Apr', y: 0 },
    { x: 'May', y: 0 },
    { x: 'Jun', y: 500 },
    { x: 'Jul', y: 0 },
    { x: 'Aug', y: 0 },
    { x: 'Sep', y: 0 },
    { x: 'Oct', y: 0 },
    { x: 'Nov', y: 0 },
    { x: 'Dec', y: 0 },
  ];

  return (
    <VictoryChart width={1000} height={300}>
      <VictoryAxis
        tickValues={emptyData.map((d) => d.x)}
        tickFormat={(tick) => tick}
      />
      <VictoryAxis dependentAxis />
      <VictoryLine
        data={emptyData}
        style={{
          data: { stroke: 'grey', strokeWidth: 2 },
        }}
      />
      <VictoryLabel
        text="No Data Available"
        x={200}
        y={150}
        textAnchor="middle"
        verticalAnchor="middle"
        style={{ fontSize: 18, fill: 'grey' }}
      />
    </VictoryChart>
  );
};

export default EmptyStateChart;
